export const PAGE_SIZE_OPTIONS = ['5', '10', '25', '50'];

export const defaultPagination = {
	current: 1,
	pageSize: 10,
	pageSizeOptions: PAGE_SIZE_OPTIONS,
	showSizeChanger: true,
};
